import { render, staticRenderFns } from "./zbtsnrList.vue?vue&type=template&id=37df5454&scoped=true&"
import script from "./zbtsnrList.vue?vue&type=script&lang=js&"
export * from "./zbtsnrList.vue?vue&type=script&lang=js&"
import style0 from "./zbtsnrList.vue?vue&type=style&index=0&id=37df5454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df5454",
  null
  
)

export default component.exports